import { type FC } from 'react';
import { Button, Text } from '@chakra-ui/react';
import { translateAndFormat } from '../../../../constants/translation';

interface Props {
  searchPhrase: string;
  onGlobalResultsRequested: (searchPhrase: string) => void;
}

export const GlobalResultsButton: FC<Props> = ({ searchPhrase, onGlobalResultsRequested }) => {
  return (
    <Button
      className="global-results-link-button"
      variant="link"
      onClick={e => {
        onGlobalResultsRequested(searchPhrase);
        e.stopPropagation();
      }}
    >
      <Text className="global-results-link" as="a">
        {translateAndFormat('SEE_GLOBAL_RESULTS_FOR', searchPhrase)}
      </Text>
    </Button>
  );
};
